// Shared batch presentation helpers for the Simulations surfaces.
import type { components } from "../../api/schema";
import { defaultBatchDisplayName } from "../../lib/batch";
import { shortResourceId } from "../../lib/shellNavigation";

type BatchResponse = components["schemas"]["BatchResponse"];

export function batchDisplayLabel(batch: BatchResponse): string {
  return (
    batch.display_name ?? defaultBatchDisplayName(new Date(batch.created_at))
  );
}

// Scheduled provenance is a fact only when both server fields are present.
// `template_id` alone is not enough: it also describes manual runs launched
// from a saved template.
export function scheduledTemplateLabel(
  batch: BatchResponse,
  templateNamesById: ReadonlyMap<string, string>,
): string | null {
  if (batch.template_id === null || batch.scheduled_fire_at === null) {
    return null;
  }
  const templateName = templateNamesById.get(batch.template_id);
  return templateName === undefined
    ? `Scheduled · Template ${shortResourceId(batch.template_id)}`
    : `Scheduled · ${templateName}`;
}

export function historyStatusTone(
  status: BatchResponse["status"],
): "danger" | "neutral" | "success" {
  if (status === "failed") {
    return "danger";
  }
  if (status === "done") {
    return "success";
  }
  return "neutral";
}
